import { createRequestTypes } from 'common/websocket-redux';

export const GET_PRICING_SCENARIO_REPORT = createRequestTypes(
  'admin/employer-reports/GET_PRICING_SCENARIO_REPORT',
);
